const value = {
    imageIsTooBig: 'Image is too large. Please upload an image no more that 5 MB.',
    imageIsTooSmall: 'Image is too small. Minimum image size is 600 x 500 px',
    incorrectImageFormat: 'Invalid file format. Allowed formats: PNG, JPG, JPEG.',
    dragAndDropMessage_1: 'drag and drop or',
    dragAndDropMessage_2: 'select a file',
    aspectRatio: 'aspect ratio 4 x 3',
    minSize: 'minimum size 600 x 500 px',
    acceptableFormats: 'PNG, JPG, JPEG, no more than 5 MB',
    backgroundRequirements: 'transparent or monochrome background',
  };

export default value;
